import { render } from "./ArrowCircleDown.vue?vue&type=template&id=3c94baee"
import script from "./ArrowCircleDown.vue?vue&type=script&lang=js"
export * from "./ArrowCircleDown.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3c94baee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c94baee', script)) {
    api.reload('3c94baee', script)
  }
  
  module.hot.accept("./ArrowCircleDown.vue?vue&type=template&id=3c94baee", () => {
    api.rerender('3c94baee', render)
  })

}

script.__file = "src/icons/components/outlined/ArrowCircleDown.vue"

export default script